import { APICore } from "./apiCore";

const api = new APICore()

function getClientes(params:any): any{
    const baseUrl = "/clientes"
    return api.get(baseUrl,params)
}

function getCliente(id:String): any{
    const baseUrl = `/clientes/${id}`
    return api.get(baseUrl,{})
}

function addCliente(params:any): any{
    // console.log("ADDMANT ",params)
    const baseUrl = "/clientes"
    return api.create(baseUrl,params)
}

function updateCliente(params:any): any{
    const baseUrl = "/clientes"
    return api.update(baseUrl,params)
}

function deleteCliente(params:any): any{
    // console.log(params)
    const baseUrl = "/clientes"
    return api.delete(baseUrl,params)
}

export {getClientes,getCliente,addCliente,updateCliente,deleteCliente}